import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getTodayPlan } from './api';

/**
 * Today's test for a learner who finished onboarding.
 *
 * The answer changes when a test is finished and when the day rolls over, so it
 * refetches on every mount and whenever the tab regains focus (the app default
 * is not to refetch on focus, which would leave yesterday's "done" on screen).
 */
export function useTodayPlan() {
  const { state } = useAuthContext();
  const user = state.user;
  return useQuery({
    queryKey: ['study-plan', 'today', user?.id],
    queryFn: ({ signal }) => getTodayPlan(signal),
    enabled: Boolean(user?.id && user.learnerProfile),
    refetchOnWindowFocus: true,
  });
}
